import React from 'react';
import { cryptoTickerData } from '../mock';

const TickerItem = ({ symbol, price, change, color }) => {
  const isPositive = parseFloat(change) >= 0;
  return (
    <div className="flex items-center gap-2 whitespace-nowrap px-4">
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      <span className="text-[11px] font-medium text-neutral-300 tracking-wider">{symbol}</span>
      <span className="text-[11px] font-semibold text-white">${price}</span>
      <span className={`text-[11px] font-medium ${isPositive ? 'text-[#39D353]' : 'text-red-400'}`}>
        {isPositive ? '+' : ''}{change}%
      </span>
    </div>
  );
};

const CryptoTicker = () => {
  const items = [...cryptoTickerData, ...cryptoTickerData];
  return (
    <div className="w-full bg-black border-b border-white/5 overflow-hidden relative">
      <div className="flex items-center max-w-full">
        <div className="flex items-center gap-2 px-4 py-2 shrink-0 bg-black z-20 border-r border-white/5">
          <span className="h-2 w-2 rounded-full bg-[#39D353] neon-dot" />
          <span className="text-[11px] font-semibold text-[#39D353] tracking-[0.2em]">LIVE</span>
        </div>
        <div className="flex-1 overflow-hidden no-scrollbar relative">
          {/* left fade */}
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-12 z-10 bg-gradient-to-r from-black to-transparent" />
          {/* right fade */}
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-12 z-10 bg-gradient-to-l from-black to-transparent" />
          <div className="flex ticker-track py-2" style={{ width: 'max-content' }}>
            {items.map((c, i) => (
              <TickerItem key={`${c.symbol}-${i}`} {...c} />
            ))}
          </div>
        </div>
        <div className="text-[10px] text-neutral-500 px-4 py-2 tracking-[0.2em] shrink-0 bg-black z-20 border-l border-white/5">
          VIA COINGECKO
        </div>
      </div>
    </div>
  );
};

export default CryptoTicker;
